export default "<div>\n    <ng-content></ng-content>\n</div>"